module.exports = {"350426100":"城关镇","350426101":"梅仙镇","350426102":"西滨镇","350426103":"洋中镇","350426104":"新阳镇","350426105":"管前镇","350426106":"西城镇","350426107":"尤溪口镇","350426108":"坂面镇","350426200":"联合乡","350426201":"汤川乡","350426202":"溪尾乡","350426203":"中仙乡","350426204":"台溪乡","350426206":"八字桥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350426.json
// module id = 1095
// module chunks = 0